/* eslint-disable jsx-a11y/no-autofocus */
import React, { ForwardedRef } from 'react';
import styles from './input-component.module.css';

interface InputComponentProps {
  value?: string;
  type?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  label?: string | React.ReactElement;
  setValue?: (value: string, fieldName?: string | null) => void;
  error?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  size?: 'normal' | 'large';
  fieldName?: string | null;
  style?: React.CSSProperties;
  focusStyle?: boolean;
  labelRight?: React.ReactNode;
  inputStyle?: React.CSSProperties;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  inputWrapperStyle?: React.CSSProperties;
  inputClassName?: string;
  inputWrapperClass?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  labelStyle?: React.CSSProperties;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  containerClassName?: string;
  id?: string;
}

function InputComponent(
  {
    value,
    type = 'text',
    left,
    right,
    placeholder,
    required,
    label,
    setValue = () => {},
    error,
    disabled,
    autoFocus,
    onFocus,
    readOnly = false,
    onBlur,
    onClick,
    size = 'normal',
    fieldName = null,
    style,
    focusStyle = true,
    labelRight,
    inputStyle,
    inputProps,
    inputWrapperStyle,
    inputClassName,
    inputWrapperClass,
    onChange,
    labelStyle,
    onKeyDown,
    containerClassName,
    id = `input-${Math.random().toString(36).substr(2, 9)}`,
  }: InputComponentProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  return (
    <div
      style={style}
      className={`${styles.customInputContainer} ${size === 'large' ? styles.customInputContainerLarge : ''} ${
        containerClassName || ''
      }`}
    >
      {label && (
        <label htmlFor={id} className={styles.customInputLabel} style={labelStyle}>
          {label}
          {required && <span className={styles.customInputRequired}>*</span>}
          {labelRight}
        </label>
      )}
      <div
        style={{ ...inputWrapperStyle, border: error ? '1px solid var(--red)' : undefined }}
        className={`${styles.customInputWrapper} ${focusStyle ? styles.customInputWrapperFocus : ''} ${
          size === 'large' ? styles.wrapperLarge : ''
        } ${inputWrapperClass || ''}`}
      >
        {left}
        <input
          {...inputProps}
          id={id}
          readOnly={readOnly}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          disabled={disabled}
          className={inputClassName}
          type={type}
          placeholder={placeholder}
          value={value}
          onClick={onClick}
          onChange={(e) => {
            onChange?.(e);
            setValue(e.target.value, fieldName);
          }}
          autoFocus={autoFocus}
          onFocus={onFocus}
          style={inputStyle}
          ref={ref}
        />
        {right}
      </div>
      {error && (
        <div className={size === 'large' ? styles.customInputErrorMsgLarge : styles.customInputErrorMsg}>{error}</div>
      )}
    </div>
  );
}

export default React.forwardRef(InputComponent);
